// extracted by mini-css-extract-plugin
export var highlightFade = "_2y-4";
export var highlighted = "_2y-3";
export var table = "_2y-1";
export var tableContainer = "_2y-0";
export var totalsRow = "_2y-2";